var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-background"},_vm._l((_vm.filteredCardNames),function(card){return _c('a',{key:card.id,attrs:{"href":'#' + card.id}},[_c('div',{staticClass:"outer-nav-circle position-relative"},[_c('div',{staticClass:"nav-circle",class:{
          'bg-idle': !card.visible,
          'bg-active': card.visible,
        }}),_c('h6',{staticClass:"position-absolute nav-label"},[_vm._v(" "+_vm._s(card.title)+" ")])])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }